import React from "react";
import { outlinedButtonStyle } from "../DeferButton/DeferButton";
import { Button, ButtonProps } from "@mui/material";

type Props = {
  handleClick: () => void;
} & ButtonProps;

const BackButton = ({ handleClick, ...props }: Props) => (
  <Button
    {...props}
    variant={"outlined"}
    sx={outlinedButtonStyle}
    onClick={() => {
      handleClick();
    }}
  >
    Back
  </Button>
);

export default BackButton;
